
<template>
    <v-container class="" style="padding: 6px;">
        <!-- >>> Resource was chosen: -------------------------------------- -->
        <v-row v-if="get_flights_ResourceDetails_ResourceAskedFor.idResource !== undefined">
            <!-- >>> Left Side: -------------------------------------------- -->
            <v-col cols="6" md="3">
                <v-card class="pa-2" style="background-color: #fff;" outlined>
                    <table id="customers">
                        <thead>
                            <tr>
                                <th style="background-color: #CB67A0;">
                                    <v-card-title style="text-align: left; font-weight: 600; font-size: 14px; color: #fff;">
                                        <p>{{ get_flights_ResourceDetails_ResourceAskedFor.genLastname }}, {{ get_flights_ResourceDetails_ResourceAskedFor.genFirstName }}</p>
                                        <p>{{ get_flights_ResourceDetails_ResourceAskedFor.contractFunction }} in {{ get_flights_ResourceDetails_ResourceAskedFor.contractBaseStationCode }}, {{ get_flights_ResourceDetails_ResourceAskedFor.comPhone1 }}</p>
                                    </v-card-title>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </v-card>

                <v-card class="pa-2"  style="margin-top: 10px; background-color: #fff;" outlined>
                    <v-card-text>
                        <datetime v-model="startDate" label="Brief Date:" disabled="false" disabledTime="true" ref="startTimer" briefcaller="step2" />
                    </v-card-text>
                </v-card>

                <v-card class="pa-2" min-height="284" style="margin-top: 10px; background-color: #fff;" outlined>
                     <v-card-text style="text-align: left; font-weight: 500; font-size: 16px;">
                        <!-- >>> 'Flights this Day': ------------------------ -->
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;" v-if="flightsThisDay.length > 0">Flights this Day:</span>
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;" v-if="flightsThisDay.length === 0">No Flights this Day:</span>
                        <template v-for="(flight, index) in flightsThisDay">
                            <p style="font-size: 13px; font-weight: 500;" :key="index"><strong>{{ flight.flight }}:</strong> {{ flight.hours }} (LT), {{ flight.leg }}: {{ flight.ft }}h</p>
                        </template>

                        <!-- >>> 'Sectors': -------------------------------- -->
                        <br /><p style="font-size: 13px; font-weight: 500;" v-if="sectorsThisDay !== null"><strong>Sectors: </strong>{{ sectorsThisDay }}</p>

                        <!-- >>> 'Total FT/DT': ------------------------------- -->
                        <p style="font-size: 13px; font-weight: 500;">
                            <span v-if="totalFTThisDay !== null"><strong>FT Total: </strong>{{ totalFTThisDay }}, </span>
                            <span v-if="totalDTThisDay !== null"><strong>DT Total: </strong>{{ totalDTThisDay }}</span>
                        </p><br />

                        <!-- >>> 'Total FDP': ------------------------------ -->
                        <p style="font-size: 13px; font-weight: 500;" v-if="fdtInfo !== null"><strong>FDP Total: </strong>{{ fdtInfo.formatted_fdt }}</p>
                        <p style="font-size: 13px; font-weight: 500;" v-if="fdtInfo !== null">max {{ fdtInfo.formatted_max_fdt }}h {{ fdtInfo.formatted_max_fdt_extension }}h
                            <span style="float: right;">
                                <div class="led-green" v-if="isRedOrGreen({ semaforo: 'green', calculation: 'totalfdt' }) === 'green'"></div>
                                <div class="led-red" v-if="isRedOrGreen({ semaforo: 'red', calculation: 'totalfdt' }) === 'red'"></div>
                            </span>
                        </p><br />

                        <!-- >>> 'Extended FDP': --------------------------- -->
                        <p style="font-size: 13px; font-weight: 500;" v-if="fdtInfo !== null"><strong>FDP Extendend: </strong>{{ this.minusSeven }}-{{ this.plusSeven }}
                            <span style="float: right;">
                                <div class="led-green" v-if="isRedOrGreen2({ semaforo: 'green', calculation: 'extendedfdp' }) === 'green'"></div>
                                <div class="led-red" v-if="isRedOrGreen2({ semaforo: 'red', calculation: 'extendedfdp' }) === 'red'"></div>
                            </span>
                        </p>
                        <template v-for="(offset, index) in weekOffsetFdtExtensionsUsed">
                            <span style="font-size: 12px; font-weight: 500;" :key="index + 100"><strong>{{ index + 1}}. </strong>{{ offset.date | dayjsFormatDate3 }} {{ offset.formatted_max_fdt_extension_used}}</span>;
                        </template>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- <<< Left Side: -------------------------------------------- -->


            <!-- >>> Right Side: ------------------------------------------- -->
            <v-col cols="12" sm="6" md="9">
                <!-- >>> Table: -------------------------------------------- -->
                <v-card class="pa-2" min-height="480" style="background-color: #fff;" outlined>
                    <table class="MyFlightTimeTable">
                        <tbody>
                            <tr>
                                <td class="header_cell" style="" colspan="2">Start of FDP at <br />referencetime</td>
                                <td class="header_cell" style="">1 Sectors</td>
                                <td class="header_cell" style="">2 Sectors</td>
                                <td class="header_cell" style="">3 Sectors</td>
                                <td class="header_cell" style="">4 Sectors</td>
                                <td class="header_cell" style="">5 Sectors</td>
                                <td class="header_cell" style="">6 Sectors</td>
                                <td class="header_cell" style="">7 Sectors</td>
                                <td class="header_cell" style="">8 Sectors</td>
                                <td class="header_cell" style="">9 Sectors</td>
                                <td class="header_cell" style="">10 Sectors</td>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_1" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_2" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_3" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_4" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_5" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_6" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_7" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_8" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_9" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_10" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_11" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_12" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_13" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_14" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                            <tr>
                                <template v-for="(item, index) in yearlyList.row_15" >
                                    <td class="cell_with_value" :key="index">
                                        {{ item.value }}
                                        <span v-if="item.formatted_max_fdt_extension !== null"><br />{{ item.formatted_max_fdt_extension }} </span>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                    <span style="font-size: 12px; font-weight: 500;">Note:</span><span style="font-size: 12pxem; font-weight: 400;"> Config Flight Duty Times</span>
                </v-card>
            </v-col>
            <!-- <<< Right Side: ------------------------------------------- -->
        </v-row>
        <!-- <<< Resource was chosen: -------------------------------------- -->




        <!-- >>> Resource was not chosen yet: ------------------------------ -->
        <v-row v-if="get_flights_ResourceDetails_ResourceAskedFor.idResource === undefined">
            <v-col cols="12">
                <v-card class="pa-2" style="background-color: #fff;">
                    <v-card-title class="pa-4" style="color: #CB67A0; font-size: 15px; font-weight: 500;">
                        <i style="font-size:20px; color: #A4C2A5;" class="b-fa b-fa-check-circle"></i> Attention: Dear User, first select a resource in the upper area (click checkbox).
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <!-- <<< Resource was not chosen yet: ------------------------------ -->
    </v-container>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import dayjs from 'dayjs';
    import utc from 'dayjs/plugin/utc';


    export default {
        name: 'Step2Content',

        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                // >>> --------------------------
                yearlyList: {},
                flightsThisDay: [],
                sectorsThisDay: null,
                totalFTThisDay: null,
                totalDTThisDay: null,
                fdtInfo: null,
                weekOffsetFdtExtensionsUsed: null,
                minusSeven: null,
                plusSeven: null,
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /******************************************************************* Picker
            * watch::get_flights_CrewDetails_SavedPayload
            *
            * Desc: Monitor/Watch ... 'get_flights_CrewDetails_SavedPayload'.
            * Note:
            *
            */
            get_flights_CrewDetails_SavedPayload(v) {

                let me = this,
                    timestamp = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step2Content.vue >>> watch get_flights_CrewDetails_SavedPayload');
                if (v.date !== undefined) {
                    timestamp = new Date(v.date).setHours(23, 59, 0, 0);
                    this.startDate = new Date(timestamp);
                }

            }, // eo function get_flights_CrewDetails_SavedPayload()


            /*******************************************************************
            * watch::get_flights_ResourceDetails_FlightDutyTimeConfig
            *
            * Desc: Monitor/Watch ... 'get_flights_ResourceDetails_FlightDutyTimeConfig'.
            * Note:
            *
            */
            get_flights_ResourceDetails_FlightDutyTimeConfig(v) {

                this.yearlyList = v;

            }, // eo function get_flights_ResourceDetails_FlightDutyTimeConfig()


            /******************************************************************* Brief
            * watch::get_flights_BriefDetails_Flights_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_Flights_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_Flights_ThisDay(v) {

                this.flightsThisDay = v;

            }, // eo function get_flights_BriefDetails_Flights_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_Sectors_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_Sectors_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_Sectors_ThisDay(v) {

                this.sectorsThisDay = v;

            }, // eo function get_flights_BriefDetails_Sectors_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_TotalFT_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_TotalFT_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_TotalFT_ThisDay(v) {

                this.totalFTThisDay = v;

            }, // eo function get_flights_BriefDetails_TotalFT_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_TotalDT_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_Sectors_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_TotalDT_ThisDay(v) {

                this.totalDTThisDay = v;

            }, // eo function get_flights_BriefDetails_TotalDT_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_FlightDutyTime_FdtInfo
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_FlightDutyTime_FdtInfo'.
            * Note:
            *
            */
            get_flights_BriefDetails_FlightDutyTime_FdtInfo(v) {

                this.fdtInfo = v;

            }, // eo function get_flights_BriefDetails_FlightDutyTime_FdtInfo()


            /*******************************************************************
            * watch::get_flights_BriefDetails_FlightDutyTime_WeekOffsetFdtExtensionsUsed()
            *
            * Desc: Monitor/Watch
            * Note:
            *
            */
            get_flights_BriefDetails_FlightDutyTime_WeekOffsetFdtExtensionsUsed(v) {

                let actdate =  this.get_flights_ResourceDetails_ResourceAskedFor_Date_EventRecord; // always right?


                this.weekOffsetFdtExtensionsUsed = v;
                this.minusSeven = dayjs(actdate).subtract(7, 'day').format('DD. MMM YYYY');
                this.plusSeven 	= dayjs(actdate).add(7, 'day').format('DD. MMM YYYY');

            }, // eo function get_flights_BriefDetails_FlightDutyTime_WeekOffsetFdtExtensionsUsed()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_CrewDetails_SavedPayload',
                'get_flights_ResourceDetails_ResourceAskedFor',
                'get_flights_ResourceDetails_FlightDutyTimeConfig',
                // ------------------------------
                'get_flights_BriefDetails_Flights_ThisDay',
                'get_flights_BriefDetails_Sectors_ThisDay',
                'get_flights_BriefDetails_TotalFT_ThisDay',
                'get_flights_BriefDetails_TotalDT_ThisDay',
                'get_flights_BriefDetails_FlightDutyTime_FdtInfo',
                'get_flights_ResourceDetails_ResourceAskedFor_Date_EventRecord',
                'get_flights_BriefDetails_FlightDutyTime_WeekOffsetFdtExtensionsUsed',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step2Content.vue >>> created');
            eventBus.$on('onchangedatepickerbriefcall', this.onChange_DatePickerInBrief);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step2Content.vue >>> beforeDestroy');
            eventBus.$off('onchangedatepickerbriefcall', this.onChange_DatePickerInBrief);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_getCrewDetailsResourceBrief_Reload'
            ]),


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_DatePickerInBrief()
            *
            * Desc:
            * Desc:
            *
            * @param {String} value ()
            */
            onChange_DatePickerInBrief: function(values){

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step2Content.vue >>> onChange_DatePickerInBrief');
                if (values.caller === 'step2') {
                    me.actn_call_getCrewDetailsResourceBrief_Reload({ date: values.date });
                }

            }, // eo function onChange_DatePickerInBrief()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * isRedOrGreen()
            *
            * Desc: Decide which traffic light.
            * Note:
            *
            * @param {Object} values (e.g.: { semaforo: 'red', calculation: '28days' })
            */
            isRedOrGreen: function(values) {

                let me = this,
                    semaforo = null,
                    times = [],
                    totalFDP = this.fdtInfo.formatted_fdt,
                    formatted_max_fdt = this.fdtInfo.formatted_max_fdt,
                    formatted_max_fdt_extension = this.fdtInfo.formatted_max_fdt_extension,
                    totalFDP_Minutes = null,
                    formatted_max_fdt_Minutes = null,
                    formatted_max_fdt_extension_Minutes = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step2Content.vue >>> isRedOrGreen');
                if (values.calculation === 'totalfdt') {
                    if (totalFDP !== null) {
                        times = totalFDP.split(':');
                        totalFDP_Minutes = (parseInt(times[0], 10) * 60) + parseInt(times[1], 10);

                        times = formatted_max_fdt.split(':');
                        formatted_max_fdt_Minutes = (parseInt(times[0], 10) * 60) + parseInt(times[1], 10);

                        formatted_max_fdt_extension = formatted_max_fdt_extension.substring(1); // CUT + or - Sign
                        times = formatted_max_fdt_extension.split(':');
                        formatted_max_fdt_extension_Minutes = (parseInt(times[0], 10) * 60) + parseInt(times[1], 10);

                        if (totalFDP_Minutes > (formatted_max_fdt_Minutes + formatted_max_fdt_extension_Minutes)) {
                            semaforo = 'red';
                        } else {
                            semaforo = 'green';
                        }
                    }
                }


                return semaforo;

            }, // eo function isRedOrGreen()


            /*******************************************************************
            * isRedOrGreen2()
            *
            * Desc: Decide which traffic light.
            * Note:
            *
            * @param {Object} values (e.g.: { semaforo: 'red', calculation: '28days' })
            */
            isRedOrGreen2: function(values) {

                let me = this,
                    semaforo = null,
                    theFDPValues = this.weekOffsetFdtExtensionsUsed,
                    theFDPValues_length = theFDPValues.length,
                    checkedValue = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step2Content.vue >>> isRedOrGreen2');
                // >>> ---------------------------- PreCheck 1, always 'green'
                if (theFDPValues_length < 3) {
                    semaforo = 'green';
                }

                // >>> ---------------------------- PreCheck 2, always 'red'
                if (theFDPValues_length >= 5) {
                    semaforo = 'red';
                }

                // >>> ---------------------------- Check 3
                if (theFDPValues_length === 3 || theFDPValues_length === 4) {
                    function checkThis(val1, val2) {

                        var a = null,
                            b = null,
                            a_year = null,
                            a_month = null,
                            a_day = null,
                            b_year = null,
                            b_month = null,
                            b_day = null;


                        a_year 	= parseInt(dayjs(val1).format('YYYY'), 10);
                        a_month = parseInt(dayjs(val1).format('MM'), 10);
                        a_day 	= parseInt(dayjs(val1).format('DD'), 10);

                        b_year 	= parseInt(dayjs(val2).format('YYYY'), 10);
                        b_month	= parseInt(dayjs(val2).format('MM'), 10);
                        b_day 	= parseInt(dayjs(val2).format('DD'), 10);

                        a 		= dayjs([a_year, a_month - 1, a_day]);
                        b 		= dayjs([b_year, b_month - 1, b_day]);



                        if (b.diff(a, 'days') <= 7) {
                            return 'red'; 		// more than 2 are between 7
                        } else {
                            return 'green';
                        }

                    }

                    // >>> ------------------------ Check, 1-3, First Run
                    checkedValue = checkThis(theFDPValues[0].date, theFDPValues[2].date);


                    // >>> ------------------------ Check, 2-4, Second Run
                    if (checkedValue === 'green' && theFDPValues_length === 4) {
                        checkedValue = checkThis(theFDPValues[1].date, theFDPValues[3].date);

                    }

                    semaforo = checkedValue;

                }


                return semaforo;

            }, // eo function isRedOrGreen()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    #customers {
        border-collapse: collapse;
        width: 100%;
    }

    #customers td, #customers th {
        border: 1px solid #ddd;
        padding: 8px;
        font-size: 13px;
    }

    #customers td {
        font-weight: 500 !important;
    }


    #customers tr:nth-child(even){background-color: #f2f2f2;}

    #customers tr:hover {background-color: #ddd;}

    #customers th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #A4C2A5;
        color: white;
        font-size: 14px;
        font-weight: 600 !important;
    }





    table.MyFlightTimeTable {
        background-color: #fff;
        width: 100%;
    }
    table.MyFlightTimeTable td {
        height: 25px;
        width: 31px;
        color: #000;
        font-size: 13px;
        font-weight: 500;
        text-align: center;
    }
    table.MyFlightTimeTable .header_cell {
        background-color: #A4C2A5;
        color: #fff;
    }
    table.MyFlightTimeTable .cell_empty {
        background-color: #CB67A0;
    }
    table.MyFlightTimeTable .cell_with_value {
        background-color: #f3f4f5;
    }



    .led-green {
        margin: 0 auto;
        width: 14px;
        height: 14px;
        background-color: #A4C2A5;
        border-radius: 50%;
        /* box-shadow: rgb(0 0 0 / 20%) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #89ff00 0 2px 12px; */
    }

    .led-red {
        margin: 0 auto;
        width: 14px;
        height: 14px;
        background-color: #ff0000;
        border-radius: 50%;
        /* box-shadow: rgb(0 0 0 / 20%) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #e82e15 0 2px 12px; */
    }
</style>